import { ANY_NETWORKS, MNC_LENGTH } from '../constants';

export function formatMnc(mnc: unknown): string {
	if (typeof mnc === 'number') {
		return mnc === ANY_NETWORKS ? '%' : mnc.toString().padStart(MNC_LENGTH, '0');
	}
	return '';
}
